import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryReturnCreateView from 'src/sections/stationery-return/view/stationery-return-create-view';

export default function StationeryReturnCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new stationery return</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_STATIONERY_RETURN,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryReturnCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
